var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticStyle: { width: "100%", height: "100%" } }, [
      _c(
        "div",
        {
          ref: "map",
          staticClass: "map",
          attrs: { id: "map", type: _vm.isDarkMap ? "dark" : "light" },
          on: {
            contextmenu: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                width: "100%",
                "z-index": "100"
              }
            },
            [
              _vm.loading
                ? _c("v-progress-linear", {
                    staticStyle: { "margin-top": "0" },
                    attrs: {
                      indeterminate: true,
                      color: "accent",
                      "background-color": "white",
                      "background-opacity": "0.7",
                      height: "5"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("search-map"),
          _vm._v(" "),
          _vm.objectList.open
            ? _c("object-list", {
                directives: [
                  {
                    name: "on-clickaway",
                    rawName: "v-on-clickaway",
                    value: _vm.closeObjectList,
                    expression: "closeObjectList"
                  }
                ],
                attrs: {
                  coordinates: _vm.contextMenuPixel,
                  objectList: _vm.objectList.list
                },
                on: {
                  selectObject: _vm.selectObject,
                  "remove-highlight-from-menu":
                    _vm.removeHighlightFromObjectOnLeave
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("object-form", { ref: "objectForm" })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8810b5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8810b5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/Map/NetworkMap.vue
// module id = null
// module chunks = 